import { Helmet } from "react-helmet";

export function Meta() {
  return (
    <Helmet>
      <meta http-equiv="Content-Security-Policy" content="upgrade-insecure-requests" />{" "}
    </Helmet>
  );
}
